import { Stack, Theme, Typography } from '@mui/material';

import { ProgressDots } from '@/components/DataDisplay/Indicator/ProgressDots';
import { Page } from '@/components/Layout/Page/Page';
import { OnboardingGuide } from '@/components/OnboardingGuide';

import { useTranslate } from '@/hooks/useTranslate';

import { ApplicationType } from '@/types/user';

import { PROGRESS_STEPS } from '@/utils/progressSteps';

import ApplicationTypeSelection from './components/ApplicationTypeSelection';
import useHandleApplicationType from './hooks/useHandleApplicationType';

export const SelectApplicationTypeComponent: React.FC = () => {
  const { t } = useTranslate();

  const { handleSelectApplicationType, isPending } = useHandleApplicationType();

  const onSelect = (type: ApplicationType, isComingSoon: boolean = false) => {
    handleSelectApplicationType(type, isComingSoon);
  };

  return (
    <Page
      paperProps={{
        color: (theme: Theme) => theme.palette.neutral[1000],
        position: 'right',
        size: 'big',
        children: <OnboardingGuide />,
      }}
      headerMobile={{
        centerSlot: (
          <ProgressDots
            value={PROGRESS_STEPS.thirdPartyComplianceCheckStep.value}
            total={PROGRESS_STEPS.thirdPartyComplianceCheckStep.total}
          />
        ),
      }}
      progressProps={PROGRESS_STEPS.thirdPartyComplianceCheckStep}
      hasLogo
    >
      <Stack direction="column" spacing={4}>
        <Typography variant="h3" textAlign="left" mb={1}>
          {t('page.selectApplicationType.title')}
        </Typography>
        <ApplicationTypeSelection onSelect={onSelect} disabled={isPending} />
      </Stack>
    </Page>
  );
};

export default function ApplicationTypeSelectionPage() {
  return <SelectApplicationTypeComponent />;
}
